function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { createContext } from 'react';
import styles from './Stepper.module.scss';
import cs from 'classnames';
import en from './locales/Stepper.en.json';
import normalizeLocaleData from '../utils/i18n/normalizeLocaleData';
import AdditionalIntl from '../I18n/AdditionalIntl/AdditionalIntl';
var MESSAGES = normalizeLocaleData(en, '@dm/components.stepper');
export var StepCountContext = createContext(0);
export default function (_ref) {
  var children = _ref.children,
    className = _ref.className;
  return /*#__PURE__*/React.createElement(AdditionalIntl, {
    messages: MESSAGES,
    path: "Stepper/locales/stepper",
    namespace: "@dm/components.stepper"
  }, /*#__PURE__*/React.createElement(StepCountContext.Provider, {
    value: children.length
  }, /*#__PURE__*/React.createElement("div", {
    className: cs(styles.container, _defineProperty({}, className, className))
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.stepper
  }, children))));
}